module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "fake-header",
    staticStyle: {
      "height": "80px",
      "width": "100%",
      "background": "#218BEF"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dwbanner"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tab-one"
  }, [_c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "tab-item-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/person.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab-item-text"
  }, [_vm._v("\n            个人事项\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "active-line"
  }, [_c('div', {
    staticClass: "triangle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item active"
  }, [_c('div', {
    staticClass: "tab-item-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/legal.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab-item-text"
  }, [_vm._v("\n            法人事项\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "active-line"
  }, [_c('div', {
    staticClass: "triangle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "one-cont"
  }, [_c('div', {
    staticClass: "cont1",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "swiper-button-next swiper-button-next2",
    staticStyle: {
      "right": "264px",
      "margin-top": "54px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev swiper-button-prev2",
    staticStyle: {
      "left": "264px",
      "margin-top": "54px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper tab-swiper"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "tab-two"
  }, [_c('div', {
    staticClass: "tab-item active"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon2.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("出生")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon5.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("学习")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon3.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("工作")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon4.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("购房")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon6.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("婚姻")])])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "tab-two"
  }, [_c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon2.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("婚育")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon5.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("迁居")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon3.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("退休")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon4.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("身后事")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item-e"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination swiper-pagination2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "two-cont"
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part1"
    }
  }, [_c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508683Q444210610900101"
    }
  }, [_vm._v("\n                      事项名称：国（境）内出生登记\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part1"
    }
  }, [_c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440106MB2C79403T4440705001000"
    }
  }, [_vm._v("\n                      少数民族高考考生资格确认\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part1"
    }
  }, [_c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/1144010600750851XC4442111180001"
    }
  }, [_vm._v("\n                      创业担保贷款申请\n                    ")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/1144010600750851XC4442111689000"
    }
  }, [_vm._v("\n                      失业保险金申领\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part1"
    }
  }, [_c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440106MB2C4883494442112006000"
    }
  }, [_vm._v("\n                      不动产登记资料查询\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part1"
    }
  }, [_c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508675X4440708003001"
    }
  }, [_vm._v("\n                      内地居民结婚登记\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part1"
    }
  }, [_c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/1144010674595773915442020021001"
    }
  }, [_vm._v("\n                      生育登记\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part1"
    }
  }, [_c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508683Q444210610001001"
    }
  }, [_vm._v("\n                      市外迁入-人才引进\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part1"
    }
  }, [_c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/1144010600750851XC4442111530001"
    }
  }, [_vm._v("\n                      用人单位退休人员移交社会服务管理\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part1"
    }
  }, [_c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508683Q4442106093001"
    }
  }, [_vm._v("\n                      凭《居民死亡医学证明（推断）书》\n                    ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont1"
  }, [_c('div', {
    staticClass: "tab-two"
  }, [_c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon2.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("企业开办")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon3.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("用工招聘")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon4.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("缴费纳税")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item active"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon5.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("生产经营")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon6.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("破产注销")])])]), _vm._v(" "), _c('div', {
    staticClass: "two-cont1"
  }, [_c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part1"
    }
  }, [_c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/1144010607844173874440125017023"
    }
  }, [_vm._v("\n                      合伙企业设立登记\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part1"
    }
  }, [_c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/1144010674595773915442111836001"
    }
  }, [_vm._v("\n                      就业登记\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part1"
    }
  }, [_c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440106MB2D03995P4442024018000"
    }
  }, [_vm._v("\n                      增值税一般纳税人登记\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part1"
    }
  }, [_c('div', {
    staticClass: "conTitle"
  }, [_vm._v("住宿和餐饮业")]), _vm._v(" "), _c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440106MB2C8363X64440125009005"
    }
  }, [_vm._v("食品经营许可证核发（实施申请人承诺制的小餐饮）")])])])]), _vm._v(" "), _c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part2"
    }
  }, [_c('div', {
    staticClass: "conTitle"
  }, [_vm._v("居民服务业")]), _vm._v(" "), _c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508640B4440120017001"
    }
  }, [_vm._v("公共场所卫生许可（新证，含改、扩建)\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part3"
    }
  }, [_c('div', {
    staticClass: "conTitle"
  }, [_vm._v("药品零售")]), _vm._v(" "), _c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440106MB2C8363X6444017201100702"
    }
  }, [_vm._v("\n                      药品经营许可证核准（零售）\n                    ")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508640B4440120003002"
    }
  }, [_vm._v("\n                    医疗机构执业许可（执业登记）\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part4"
    }
  }, [_c('div', {
    staticClass: "conTitle"
  }, [_vm._v("文体旅游业")]), _vm._v(" "), _c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508624M4440119017003"
    }
  }, [_vm._v("\n                      娱乐场所从事娱乐场所经营活动审批\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part5"
    }
  }, [_c('div', {
    staticClass: "conTitle"
  }, [_vm._v("商务服务业")]), _vm._v(" "), _c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440100MB2D34863G444017802200201"
    }
  }, [_vm._v("\n                      公众聚集场所投入使用、营业前消防安全检查（告知承诺件)\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part6"
    }
  }, [_c('div', {
    staticClass: "conTitle"
  }, [_vm._v("制造业")]), _vm._v(" "), _c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508683Q4440106032000"
    }
  }, [_vm._v("\n                      印章刻制业许可证核发\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part7"
    }
  }, [_c('div', {
    staticClass: "conTitle"
  }, [_vm._v("医护保健业")]), _vm._v(" "), _c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440106734892300B444011704600001"
    }
  }, [_vm._v("\n                      动物诊疗许可证核发\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "dwPart",
    attrs: {
      "id": "part1"
    }
  }, [_c('ul', {
    staticClass: "partul flex-4"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../static/img/duowei/itemiconactive.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/114401060784417387444012501705101"
    }
  }, [_vm._v("\n                      合伙企业注销登记\n                    ")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b959ca0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Multiple.vue
// module id = 1079
// module chunks = 0